import type { ReactNode } from 'react';
import { Download, PackageCheck, ScanLine, type LucideIcon } from 'lucide-react';

const steps: [LucideIcon, string][] = [
  [Download, 'Download'],
  [PackageCheck, 'Install'],
  [ScanLine, 'Scan'],
];

/** Getting Paige Scan, as three small pictures: download it, install it, scan. */
export function ScanInstallSteps(): ReactNode {
  return (
    <ol className="paige-scan-steps-row" aria-label="Get Paige Scan">
      {steps.map(([Icon, label], i) => (
        <li key={label}>
          <span className="paige-scan-step-mark" aria-hidden="true">
            <Icon size={18} />
          </span>
          <span>
            <span className="paige-scan-step-number">{i + 1}</span> {label}
          </span>
        </li>
      ))}
    </ol>
  );
}
